import { createUseStyles } from 'react-jss';


import { colors } from "../../../utils";

var styles = {
  question: {
    display: 'flex',
    alignItems: 'top',
    margin: { bottom: '2.9rem' },

    '@media(max-width:1150px)': {
      flexDirection: 'column',
      width: '80%'
    }
  },
  descriptionBlock: {
    width: '22.4rem',
    padding: { right: '4.4rem' }
  },
  title: {
    width: '22.4rem',
    font: { weight: 700, size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    margin: [0],
    textAlign: 'right',

    '@media(max-width:1150px)': {
      textAlign: 'left'
    }
  },
  disclaimer: {
    width: '22.4rem',
    font: { weight: 400, size: '1.6rem', lineHeight: '2.4rem', style: 'italic' },
    textAlign: 'right',
    marginTop: 0,

    '@media(max-width:1150px)': {
      textAlign: 'left',
      marginTop: '0px'
    }
  },
  contentWrapper: function contentWrapper(props) {return {
      width: '100%',
      maxWidth: '64rem',
      display: 'flex',
      flexDirection: props.layout === 'HORIZONTAL' ? 'row' : 'column',

      ' & > *': {
        margin: props.layout !== 'HORIZONTAL' && {
          bottom: '1rem'
        }
      },
      '& > *:not(:last-child)': {
        marginRight: '3%'
      }
    };}
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map